module.exports = __webpack_public_path__ + "img/food_03.f8466b13.jpg";